var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25875_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6C9.75 4.3425 8.4075 3 6.75 3C5.0925 3 3.75 4.3425 3.75 6C3.75 7.6575 5.0925 9 6.75 9C8.4075 9 9.75 7.6575 9.75 6ZM11.25 7.5V9H13.5V11.25H15V9H17.25V7.5H15V5.25H13.5V7.5H11.25ZM0.75 13.5V15H12.75V13.5C12.75 11.505 8.7525 10.5 6.75 10.5C4.7475 10.5 0.75 11.505 0.75 13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25875_4954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.adf009b727664445dadd1a82ca8b41c8.svg";
export { ForwardRef as ReactComponent };